<div class="holder">
  <ul>
    @for (parentKey of getGroupedDataKeys(); track parentKey) {
      <li>
        <div (click)="toggleExpandedState(parentKey)" class="dropdown">
          @if (expandedState[parentKey]) {
            <fa-icon class="dropdown-open" icon="caret-down"></fa-icon>
          }
          @if (!expandedState[parentKey]) {
            <fa-icon icon="caret-right"></fa-icon>
          }
          {{ parentKey }}
        </div>
        @if (expandedState[parentKey]) {
          <ul>
            @for (childKey of groupedData[parentKey]; track childKey) {
              <li>
                <div>
                  @switch (childKey) {
                    @default {
                      <li class="property level1">
                        <div>{{ childKey }}: {{ groupedProperties[parentKey][childKey]}}</div>
                      </li>
                    }
                    @case ('vcloud.template.coordinates') {
                      <li>
                        <div (click)="toggleExpandedState('template.coordinates')" class="dropdown level1">
                          @if (expandedState['template.coordinates']) {
                            <fa-icon icon="caret-down"></fa-icon>
                          }
                          @if (!expandedState['template.coordinates']) {
                            <fa-icon icon="caret-right"></fa-icon>
                          }
                          vcloud.template.coordinates
                        </div>
                        @if (expandedState['template.coordinates']) {
                          <ul>
                            @for (templateinfo of groupedProperties[parentKey][childKey] | keyvalue; track templateinfo) {
                              <li class="property level2">
                                <div>{{ templateinfo.key }}: {{ templateinfo.value}}</div>
                              </li>
                            }
                          </ul>
                        }
                      </li>
                    }
                    @case ('console.resolution') {
                      <li>
                        <div (click)="toggleExpandedState('resolution')" class="dropdown level1">
                          @if (expandedState['resolution']) {
                            <fa-icon icon="caret-down"></fa-icon>
                          }
                          @if (!expandedState['resolution']) {
                            <fa-icon icon="caret-right"></fa-icon>
                          }
                          console.resolution
                        </div>
                        <!-- TODO only use a single function for objects when WMKNBN-9441 is fixed  -->
                        @if (expandedState['resolution']) {
                          <ul>
                            @for (key of getNonNestedKeys(groupedProperties[parentKey][childKey]); track key) {
                              <li class="property level2">
                                <div>{{ key }}: {{ groupedProperties[parentKey][childKey][key] }}</div>
                              </li>
                            }
                          </ul>
                        }
                      </li>
                    }
                    @case ('machine.browsers') {
                      <li>
                        <div (click)="toggleExpandedState('browsers')" class="dropdown level1">
                          @if (expandedState['browsers']) {
                            <fa-icon icon="caret-down"></fa-icon>
                          }
                          @if (!expandedState['browsers']) {
                            <fa-icon icon="caret-right"></fa-icon>
                          }
                          machine.browsers
                        </div>
                        @if (expandedState['browsers']) {
                          <ul>
                            @for (browser of groupedProperties[parentKey][childKey]; track browser) {
                              <li>
                                <div>
                                  <div (click)="toggleExpandedState(getBrowserKey(browser))" class="dropdown level2">
                                    @if (expandedState[getBrowserKey(browser)]) {
                                      <fa-icon icon="caret-down"></fa-icon>
                                    }
                                    @if (!expandedState[getBrowserKey(browser)]) {
                                      <fa-icon icon="caret-right"></fa-icon>
                                    }
                                    {{ getBrowserKey(browser) }}
                                  </div>
                                  @if (expandedState[getBrowserKey(browser)]) {
                                    <ul>
                                      @for (key of getNonNestedKeys(browser); track key) {
                                        <li class="property level3">
                                          <div>{{ key }}: {{ browser[key] }}</div>
                                        </li>
                                      }
                                      <li>
                                        <div (click)="toggleExpandedState(getBrowserKey(browser) + '.browser.properties')" class="dropdown level3">
                                          @if (expandedState[getBrowserKey(browser) + '.browser.properties']) {
                                            <fa-icon icon="caret-down"></fa-icon>
                                          }
                                          @if (!expandedState[getBrowserKey(browser) + '.browser.properties']) {
                                            <fa-icon icon="caret-right"></fa-icon>
                                          }
                                          Properties
                                        </div>
                                        @if (expandedState[getBrowserKey(browser) + '.browser.properties']) {
                                          <ul>
                                            @for (prop of browser.properties | keyvalue; track prop) {
                                              <li class="property level4">
                                                <div>{{ prop.key }}: {{ prop.value | json }}</div>
                                              </li>
                                            }
                                          </ul>
                                        }
                                      </li>
                                      <li>
                                        <div (click)="toggleExpandedState(getBrowserKey(browser) + '.browser.capabilities')" class="dropdown level3">
                                          @if (expandedState[getBrowserKey(browser) + '.browser.capabilities']) {
                                            <fa-icon icon="caret-down"></fa-icon>
                                          }
                                          @if (!expandedState[getBrowserKey(browser) + '.browser.capabilities']) {
                                            <fa-icon icon="caret-right"></fa-icon>
                                          }
                                          Capabilities
                                        </div>
                                        @if (expandedState[getBrowserKey(browser) + '.browser.capabilities']) {
                                          <ul>
                                            @for (cap of browser.capabilities | keyvalue; track cap) {
                                              <li class="property level4">
                                                <div>{{ cap.key }}: {{ cap.value }}</div>
                                              </li>
                                            }
                                          </ul>
                                        }
                                      </li>
                                    </ul>
                                  }
                                </div>
                              </li>
                            }
                          </ul>
                        }
                      </li>
                    }
                  }
                </div>
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>
</div>

